<template>
  <main id="industrialPark" v-if="industrialPark">
    <div id="content">
      <router-link
        class="contentItem"
        v-for="(indus, index) in industrialPark.slice(0, 10 * this.index)"
        :key="index"
        :to="`industry?townIds=${indus.id}`"
      >
        <img :src="indus.image" :alt="indus.title" />
        <h3>
          {{ indus.title }}
        </h3>
      </router-link>
    </div>
    <button
      id="seeMoreINdus"
      v-if="index <= industrialPark.length / 10 && $root.globalData"
      @click="showMore()"
    >
      {{ $root.globalData.keys.show_more_text  }}
    </button>
  </main>
  <loader v-else />
</template>
<script>
import loader from "../components/loader.vue";
export default {
  components: { loader },
  mounted() {
    if (this.industrialPark == null) {
      this.$store.dispatch("getIndustrialParkFromServer");
    }
  },
  data() {
    return {
      index: 1,
    };
  },
  methods: {
    showMore() {
      this.index++;
    },
  },
  computed: {
    industrialPark() {
      return this.$store.getters.getIndustrialPark;
    },
  },
};
</script>
<style>
div#content .contentItem h3 {
  color: black;
  font-family: "IRANSans";
  font-size: 16px;
}
div#content .contentItem img {
  width: 100%;
  border-radius: 5px;
}
div#content .contentItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: white;
  box-shadow: 0 0 5px #00000025;
  padding: 5px;
  border-radius: 5px;
}
div#content {
  grid-template-columns: repeat(4, 1fr);
  width: 98%;
  margin: 50px auto;
  display: grid;
  gap: 10px;
}
@media (max-width: 800px) {
  div#content {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 500px) {
  div#content {
    grid-template-columns: repeat(2, 1fr);
  }
}
#seeMoreINdus {
  padding: 5px 15px;
  border-radius: 5px;

  color: white;
  background: #428efd;
  transition: all 1s;
}
#seeMoreINdus :hover {
  color: #428efd;
  background: white;
}
</style>
